import { useQuery } from "@tanstack/react-query";
import { callApi } from "../utils/ApiCallPostOnly";

export const useUserBranches = () => {
  return useQuery({
    queryKey: ["userBranchListState"],
    queryFn: async () =>
      callApi({
        path: "userbranchlist",
        command: "",
        data: "{}",
      }),
  });
};
